<script>

    import UsersLoginComponent from './component.login.svelte'
    import UsersRecoverComponent from './component.recover.svelte'

    const logoSrc = '/images/TIL.png'
    const logoAlt = 'TIL — Tecnología en Integración Logística'

    let mode = 'login'
    let email = ''

    function recover(event) {
        email = event.detail || ''
        mode = 'recover'
    }

</script>

<div class="login-page">
    <div class="login-page__glow login-page__glow--a" aria-hidden="true"></div>
    <div class="login-page__glow login-page__glow--b" aria-hidden="true"></div>

    <main class="login-shell">
        <header class="login-brand">
            <p class="login-brand__eyebrow">Panel administrativo</p>
            <h1 class="login-brand__title">Bienvenido</h1>
            <p class="login-brand__subtitle">
                Tecnología en Integración Logística
            </p>
        </header>

        <section class="login-card" aria-labelledby="login-heading">
            {#if mode === 'login'}
                <h2 id="login-heading" class="login-card__heading">Iniciar sesión</h2>
                <p class="login-card__hint">
                    Ingresa con tu cuenta de administrador, asesor o almacén.
                </p>
                <UsersLoginComponent on:recover={recover} />
            {:else}
                <h2 id="login-heading" class="login-card__heading">Recuperar contraseña</h2>
                <p class="login-card__hint">
                    Te enviaremos un código de 6 dígitos a tu correo para crear una nueva contraseña.
                </p>
                <UsersRecoverComponent {email} on:back={() => mode = 'login'} />
            {/if}
        </section>

        <p class="login-footer">
            <span class="login-footer__mark">TIL</span>
            <span class="login-footer__sep" aria-hidden="true">·</span>
            Acceso restringido
        </p>
    </main>
</div>

<style lang="scss">
    .login-page {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 100vh;
        padding: 1.5rem;
        overflow: hidden;
        background:
            radial-gradient(circle at 12% 8%, rgba(255, 255, 255, 0.95) 0, transparent 42%),
            radial-gradient(circle at 88% 92%, rgba(255, 255, 255, 0.7) 0, transparent 38%),
            linear-gradient(165deg, #f7f8fb 0%, var(--til-bg) 48%, var(--til-blue-100) 100%);
    }

    .login-page__glow {
        position: absolute;
        border-radius: 50%;
        pointer-events: none;
        filter: blur(60px);
    }

    .login-page__glow--a {
        top: -8rem;
        right: -4rem;
        width: 22rem;
        height: 22rem;
        background: rgba(251, 191, 36, 0.18);
    }

    .login-page__glow--b {
        bottom: -6rem;
        left: -5rem;
        width: 18rem;
        height: 18rem;
        background: rgba(255, 255, 255, 0.75);
    }

    .login-shell {
        position: relative;
        z-index: 1;
        width: 100%;
        max-width: 26rem;
        display: grid;
        gap: 1.25rem;
    }

    .login-brand {
        text-align: center;
    }

    .login-brand__logo-wrap {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 0.75rem;
        padding: 0.875rem 1.125rem;
        border-radius: var(--til-radius-lg);
        background: rgba(255, 255, 255, 0.72);
        border: 1px solid rgba(255, 255, 255, 0.9);
        box-shadow: var(--til-shadow-soft);
        backdrop-filter: blur(16px);
    }

    .login-brand__logo {
        display: block;
        width: auto;
        max-width: 200px;
        height: auto;
    }

    .login-brand__eyebrow {
        margin: 0 0 0.35rem;
        font-size: 0.6875rem;
        font-weight: 600;
        letter-spacing: 0.12em;
        text-transform: uppercase;
        color: var(--til-muted);
    }

    .login-brand__title {
        margin: 0;
        font-size: 1.75rem;
        font-weight: 700;
        letter-spacing: -0.04em;
        line-height: 1.15;
        color: var(--til-ink);
    }

    .login-brand__subtitle {
        margin: 0.35rem 0 0;
        font-size: 0.8125rem;
        color: var(--til-muted);
    }

    .login-card {
        padding: 1.5rem 1.375rem 1.375rem;
        border-radius: var(--til-radius-xl);
        background: rgba(255, 255, 255, 0.82);
        border: 1px solid rgba(255, 255, 255, 0.9);
        box-shadow: var(--til-shadow);
        backdrop-filter: blur(22px);
    }

    .login-card__heading {
        margin: 0;
        font-size: 1.125rem;
        font-weight: 700;
        letter-spacing: -0.03em;
        color: var(--til-ink);
    }

    .login-card__hint {
        margin: 0.35rem 0 1.25rem;
        font-size: 0.8125rem;
        line-height: 1.45;
        color: var(--til-muted);
    }

    .login-footer {
        margin: 0;
        text-align: center;
        font-size: 0.75rem;
        color: var(--til-muted);
    }

    .login-footer__mark {
        font-weight: 700;
        letter-spacing: 0.06em;
        color: #5d616d;
    }

    .login-footer__sep {
        margin: 0 0.35rem;
        opacity: 0.5;
    }

    @media screen and (max-width: 480px) {
        .login-page {
            padding: 1rem;
            align-items: flex-start;
            padding-top: 2rem;
        }

        .login-card {
            padding: 1.25rem 1.125rem;
        }

        .login-brand__title {
            font-size: 1.5rem;
        }
    }
</style>
